import {Injectable} from '@angular/core';
import {MedicalRecordVisitReasonDataService} from './medicalRecordVisitReasonData.service';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalRecordVisitReasonModel} from '../../../api/model/medicalRecordVisitReason.model';
import {MedicalRecordVisitReasonConverter} from '../../../api/converter/medicalRecordVisitReason.converter';

@Injectable({providedIn: 'root'})
export class MedicalRecordVisitReasonDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<MedicalRecordVisitReasonModel, MedicalRecordVisitReasonConverter> {
    constructor(dataService: MedicalRecordVisitReasonDataService, converter: MedicalRecordVisitReasonConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): MedicalRecordVisitReasonModel {
        return new MedicalRecordVisitReasonModel();
    }
}
